import { render } from "./InsideFooter.vue?vue&type=template&id=80ad1a12&scoped=true"
import script from "./InsideFooter.vue?vue&type=script&lang=js"
export * from "./InsideFooter.vue?vue&type=script&lang=js"

import "./InsideFooter.vue?vue&type=style&index=0&id=80ad1a12&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ad1a12"]])

export default __exports__